<app-loader></app-loader>
<form [formGroup]="resetForm">

    <div class="resetpassword-outer" *ngIf="firstDiv">
        <div class="change-password">
            <div class="top-headings">
                <div class="reset-text">
                    <h4>Reset Password</h4>
                    <p>Please enter your email/mobile number to request a password reset</p>
                </div>
                <div class="close-icon">
                    <img src="assets/images/export-close.svg" (click)="check()" alt="Close"/>
                </div>
            </div>
        </div>

        <div class="email-inputouter">
            <label for="otpEmail">Email/Mobile Number</label>

            <input type="text" formControlName="otpEmail" pInputText placeholder="Enter Email or Mobile Number" />

            <div
                *ngIf="resetForm.get('otpEmail')?.hasError('required')  && (resetForm.get('otpEmail')?.dirty || resetForm.get('otpEmail')?.touched)">
                <div class="validation-error"> This field is required*</div>
            </div>
            <div
                *ngIf="resetForm.get('otpEmail')?.hasError('invalidEmail') && (resetForm.get('otpEmail')?.dirty || resetForm.get('otpEmail')?.touched)">
                <div class="validation-error"> Please enter a valid email*</div>
            </div>
            <div
                *ngIf="resetForm.get('otpEmail')?.hasError('invalidPhone') && (resetForm.get('otpEmail')?.dirty || resetForm.get('otpEmail')?.touched)">
                <div class="validation-error"> Please enter a valid mobile number*</div>
            </div>
        </div>
        <div class="save-btn">
            <p-button label="Send Passcode" (onClick)="sendOtp()"></p-button>
        </div>

    </div>
    <div class="verfication-outer" *ngIf="secondDiv">

        <div class="change-password">
            <div class="top-headings">
                <div class="reset-text">
                    <h4>Verification</h4>
                    <p>Please type the verification code.
                    </p>
                </div>

<div class="close-icon">
                    <img src="assets/images/export-close.svg" (click)="check()" alt="Close"/>
                </div>
            </div>
        </div>
        <div class="otp-outer"><ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                [config]="config"></ng-otp-input></div>
        <div class="save-btn">
            <p-button (onClick)="verifyEmailByOTP()" label="Continue"></p-button>
        </div>
        <div class="reset-text">
            <p>I didn’t receive a code!
                <a *ngIf="!showButton" class="resend">Resend passcode in {{ countDown }}</a>
                <a href="#" *ngIf="showButton" (click)="onClickSendOtp($event)">Resend Passcode</a>
        </div>
    </div>
    <div class="new-password" *ngIf="thirdDiv">
        <div class="change-password">
            <div class="top-headings">
                <div class="reset-text">
                    <h4>New Password </h4>
                    <p>Set the new password for your account so you can login and access all features.</p>
                </div>
                <div class="close-icon">
                    <img src="assets/images/export-close.svg" (click)="check()" alt="Close"/>
                </div>
            </div>
        </div>
        <div class="email-inputouter">
            <label for="newPassword">New Password</label>
            <p-password id="newPassword" [toggleMask]="true" formControlName="newPassword" placeholder="Enter New Password"
                [feedback]="false"></p-password>
            <div
                *ngIf="resetForm.get('newPassword')?.hasError('required')  && (resetForm.get('newPassword')?.dirty || resetForm.get('newPassword')?.touched)">
                <div class="validation-error"> This field is required*</div>
            </div>
            <div class="error-outer" *ngIf="resetForm.get('newPassword').invalid && (resetForm.get('newPassword').dirty || resetForm.get('newPassword').touched)">
                <div *ngIf="resetForm.get('newPassword').hasError('invalidPassword')" class="validation-error">
                    Length must be 8-15 with uppercase, lowercase, number & special characters.
                </div>
            </div>
        </div>
        <div class="email-inputouter mt-3">
            <label for="confirmPassword">Confirm Password</label>
            <p-password id="confirmPassword" placeholder="Enter Confirm Password" [toggleMask]="true" formControlName="confirmPassword"
                [feedback]="false"></p-password>
            <div
                *ngIf="resetForm.get('confirmPassword')?.hasError('required')  && (resetForm.get('confirmPassword')?.dirty || resetForm.get('confirmPassword')?.touched)">
                <div class="validation-error"> This field is required*</div>
            </div>
            <div class="error-outer" *ngIf="resetForm.get('confirmPassword').invalid && (resetForm.get('confirmPassword').dirty || resetForm.get('confirmPassword').touched)">
                <div *ngIf="resetForm.get('confirmPassword').hasError('invalidPassword')" class="validation-error">
                    Length must be 8-15 with uppercase, lowercase, number & special characters.
                </div>
            </div>
        </div>
        <div class="save-btn">
            <p-button label="Save Password" (onClick)="checkPassword()"></p-button>
        </div>
    </div>

</form>
